<template>
  <a-drawer
    :maskClosable="false"
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onCloseConfirm(() => (open = false))"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="套餐名称" prop="packageName">
        <a-input v-model="form.packageName" placeholder="请输入(200元30G/年主套餐)" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="套餐类型" prop="packageType" v-if="!form.packagePid">
        <a-select
          show-search
          :allowClear="true"
          v-model="form.packageType"
          placeholder="请选择"
          option-filter-prop="children"
          :filter-option="filterOption"
          :disabled="form.packageTypeDisabled"
        >
          <a-select-option v-for="d in packageTypes" :key="d.id">{{ d.name }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="套餐容量" prop="capacity">
        <a-input-group compact>
          <a-input
            v-model="form.capacity"
            oninput="value = value.replace(/[^\d.]/g, '').replace(/^\./, '').replace(/\.{2,}/g, '.').replace(/(?<=\.\d{2}).*/, '').replace(/(?<=\d+)\./, (m, i, str) => str.indexOf('.') === i ? m : '')"
            placeholder="请输入容量"
            :maxLength="50"
            style="width: calc(100% - 80px)"
          />
          <a-select
            v-model="form.capacityUnit"
            style="width: 80px"
            @change="handleCapacityUnitChange"
          >
            <a-select-option value="MB">MB</a-select-option>
            <a-select-option value="GB">GB</a-select-option>
            <a-select-option value="TB">TB</a-select-option>
          </a-select>
        </a-input-group>
      </a-form-model-item>
      <a-form-model-item label="套餐价格" prop="price">
        <a-input
          v-model="form.price"
          placeholder="请输入(元)"
          :maxLength="20"
          oninput="value = value.replace(/[^\d.]/g, '').replace(/^\./, '').replace(/\.{2,}/g, '.').replace(/(?<=\.\d{2}).*/, '').replace(/(?<=\d+)\./, (m, i, str) => str.indexOf('.') === i ? m : '')"
          @blur="calculateUnitPrice"
        />
      </a-form-model-item>
      <a-form-model-item label="单价" prop="unitPrice">
        <a-input
          v-model="form.unitPrice"
          placeholder="请输入单价(元/GB)"
          :maxLength="20"
          oninput="value = value.replace(/[^\d.]/g, '').replace(/^\./, '').replace(/\.{2,}/g, '.').replace(/(?<=\.\d{2}).*/, '').replace(/(?<=\d+)\./, (m, i, str) => str.indexOf('.') === i ? m : '')"
          @blur="formatUnitPrice"
        />
      </a-form-model-item>
      <a-form-model-item label="有效期(天)" prop="validDays" v-if="showTime">
        <a-input
          :disabled="true"
          v-model="form.validDays"
          placeholder="请输入(天)"
          :maxLength="20"
          oninput="value=value.replace(/[^\d]/g,'')"
        />
      </a-form-model-item>
      <a-form-model-item label="套餐描述	" prop="description">
        <a-textarea v-model="form.description" placeholder="请输入套餐描述" :maxLength="200" :rows="3" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="form.remark" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort">
        <a-input v-model="form.sort" placeholder="请输入" :maxLength="20" oninput="value=value.replace(/[^\d]/g,'')" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { mapGetters } from 'vuex'
import { getObj, addObj, putObj } from '@/api/VR/storagePackage'
import parameter from '@/mixins/parameter'
export default {
  name: 'CreateForm',
  components: {},
  mixins: [parameter],
  data() {
    return {
      submitLoading: false,
      showLoading: false,
      data: [],
      showTime: true,
      formTitle: '',
      form: {
        id: undefined,
        capacity: undefined,
        capacityUnit: 'GB', // 默认GB
        description: undefined,
        packageName: undefined,
        packageType: 1, // 默认安心套餐
        packageTypeDisabled: false, // 是否禁用套餐类型选择
        price: undefined,
        remark: undefined,
        unitPrice: undefined,
        validDays: 365,
        sort: 99,
      },
      open: false,
      hour: [],
      hours: [],
      minute: [],
      minutes: [],
      rules: {
        capacity: [{ required: true, message: '请输入套餐容量', trigger: 'blur' }],
        packageName: [{ required: true, message: '请输入套餐名称', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
        packageType: [{ required: true, message: '请选择套餐类型', trigger: 'blur' }],
        unitPrice: [{ required: false, message: '请输入单价(元/GB)', trigger: 'blur' }],
        price: [{ required: true, message: '请输入套餐价格', trigger: 'blur' }],
        validDays: [{ required: true, message: '请输入有效期(天)', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {
    console.log('statusOptions 显示隐藏', this.statusOptions)
  },
  computed: {
    ...mapGetters(['userTentant', 'infoUser']),
  },
  watch: {},
  methods: {
    onClose() {
      const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          console.log(that.open, 'openopen')
          that.open = false
        },
        onCancel() {},
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 容量单位转换方法
    convertToMB(capacity, unit) {
      if (!capacity) return 0
      const num = parseFloat(capacity)
      switch (unit) {
        case 'TB':
          return num * 1024 * 1024
        case 'GB':
          return num * 1024
        case 'MB':
          return num
        default:
          return num
      }
    },
    // 容量单位改变事件处理
    handleCapacityUnitChange() {
      this.calculateUnitPrice()
    },
    // 计算单价 (元/GB) - 只在套餐价格修改时触发
    calculateUnitPrice() {
      // 只有当套餐价格有值且容量有值时才计算
      if (this.form.capacity && this.form.price) {
        const capacityInGB = this.convertToMB(this.form.capacity, this.form.capacityUnit) / 1024
        // 仅在套餐价格变化时更新单价，单价手动输入时不覆盖
        if (capacityInGB > 0) {
          this.form.unitPrice = (this.form.price / capacityInGB).toFixed(2)
        }
      }
    },
    // 格式化单价，确保只保留两位小数
    formatUnitPrice() {
      if (this.form.unitPrice) {
        const num = parseFloat(this.form.unitPrice)
        if (!isNaN(num)) {
          this.form.unitPrice = num.toFixed(2)
        }
      }
    },
    cancel() {
      this.onCloseConfirm(() => (this.open = false))
    },
    onCloseConfirm(okFn) {
      this.$confirm({
        title: '关闭后已填数据将被清空，是否继续？',
        onOk: okFn,
        onCancel: () => {},
      })
    },
    reset() {
      this.form = {
        id: undefined,
        capacity: undefined,
        capacityUnit: 'GB', // 默认GB
        description: undefined,
        packageName: undefined,
        packageType: 1, // 默认安心套餐
        packageTypeDisabled: false, // 是否禁用套餐类型选择
        price: undefined,
        remark: undefined,
        unitPrice: undefined,
        validDays: 365,
        sort: 99,
      }
    },
    handleAdd(e, selectedPackageType) {
      this.reset()
      if (e) {
        this.form.packagePid = e.id
        this.form.packageType = 3
        this.showTime = e.showTime
      } else if (selectedPackageType) {
        // 根据主页面选择的类型设置套餐类型，并禁用选择
        this.form.packageType = selectedPackageType
        this.form.packageTypeDisabled = true
      }
      this.open = true
      this.formTitle = '新增套餐规则'
    },
    handleUpdate(row, ids) {
      this.reset()
      const postId = row ? row.id : ids
      getObj(postId).then((response) => {
        this.form = {
          ...response.data,
          packageTypeDisabled: false, // 编辑时不禁用套餐类型选择
        }
        this.open = true
        this.formTitle = '修改套餐规则'
      })
    },
    submitForm: function () {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          // 将容量转换为MB后提交，保持套餐价格不变
          const submitData = {
            ...this.form,
            capacity: this.convertToMB(this.form.capacity, this.form.capacityUnit),
            // 确保套餐价格保持原值，不因单价变化而改变
            price: this.form.price,
          }

          this.submitLoading = true
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(1)
          })
          if (this.form.id !== undefined) {
            putObj(submitData)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          } else {
            addObj(submitData)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          }
        } else {
          const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
/deep/.ant-form-item {
  margin-bottom: 0 !important;
}
</style>
